<div class="status-badge" [ngClass]="'status-' + currentStatus.className">
  <mat-icon class="icon-width" [svgIcon]="'nx:' + currentStatus.icon" />
  <span class="twc-typography-body-2-medium ignore-archived auto-ellipsis">
    {{ currentStatus.name }}
  </span>
  <div class="display-flex align-items-center">
    <ng-content></ng-content>
  </div>
</div>
